import type { ConnectionState, RealtimeClient, Unsubscribe } from './types'

/**
 * Used when no WebSocket base URL is configured: never connects, stays `idle`, and accepts
 * subscriptions that receive nothing. Not a simulation — there is no realtime data without a backend.
 */
export class IdleRealtimeClient implements RealtimeClient {
  readonly state: ConnectionState = 'idle'

  connect(): void {
    // nothing to connect to
  }

  disconnect(): void {
    // never connected
  }

  onStateChange(): Unsubscribe {
    return () => undefined
  }

  subscribe(): Unsubscribe {
    return () => undefined
  }
}
